import { Sku } from './Sku'
import moment from 'moment'

export interface OrderInterface {
  id: number
  count: number
  price: number
  total: number
  orderDate: string
  project: string
  projectId: number
  brand: string
  brandId: number
  product: string
  productId: number
  tags: string
  productSkuDTO: Sku
}

export class Order {
  readonly id: number
  readonly count: number
  readonly price: number
  readonly total: number
  readonly orderDate: Date
  readonly projectName: string
  readonly projectId: number
  readonly brandName: string
  readonly brandId: number
  readonly productName: string
  readonly productId: number
  readonly tags: string[]
  readonly productSku: Sku

  constructor (order: OrderInterface) {
    this.id = order.id
    this.count = order.count
    this.price = order.price
    this.total = order.total
    this.orderDate = new Date(order.orderDate)
    this.projectName = order.project
    this.projectId = order.projectId
    this.brandName = order.brand
    this.brandId = order.brandId
    this.productName = order.product
    this.productId = order.productId
    this.tags = order.tags ? order.tags.split(',').map(t => t.trim()) : []
    this.productSku = order.productSkuDTO
  }

  get totalPrice () {
    return this.count * this.price
  }

  get dateAsString () {
    return moment(this.orderDate).format('HH:mm, DD MMM YYYY')
  }

  get image () {
    return this.productSku.images
      ? this.productSku.images[0]
        ? this.productSku.images[0].url
        : null
      : null
  }
}
